import React from 'react';
import ConfiguracionProduccionTabs from '../components/ConfiguracionProduccionTabs';
import Presentacion from '../components/datosfijos/Presentacion';
import FardosConfig from '../components/FardosConfig';
import CalculoSemillas from '../components/datosfijos/CalculoSemillas';
import PlayaModulosRollos from '../components/datosfijos/PlayaModulosRollos';
import ListadoSilobolsa from '../components/silobolsa/listado_silobolsa';
import { PageWrapper } from '../components/common';

const ConfiguracionProduccion: React.FC = () => {
  return (
    <PageWrapper>
      <ConfiguracionProduccionTabs
        presentacionesComponent={<Presentacion />}
        fardosComponent={<FardosConfig />}
        playaComponent={<PlayaModulosRollos />}
        semillasComponent={<CalculoSemillas />}
        silobolsaComponent={<ListadoSilobolsa />}
      />
    </PageWrapper>
  );
};

export default ConfiguracionProduccion;

